import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import {
    CUSTOM_PRODUCT_DEVELOPMENT,
    PRODUCT_DEVELOPMENT_START,
} from "@constants";
import "../NavLinks.scss";

const Dropdown = ({ path }) => {
    const linkClassName = classNames("header-links__link", {
        "header-links__link-active":
            path === CUSTOM_PRODUCT_DEVELOPMENT ||
            path === PRODUCT_DEVELOPMENT_START,
    });

    return (
        <div className="header-links__dropdown">
            <button className={linkClassName} type="button">
                Product development
            </button>
            <div className="header-links__dropdown-content">
                <Link
                    to={PRODUCT_DEVELOPMENT_START}
                    className="header-links__dropdown-link header-links__link"
                >
                    For startups
                </Link>
                <Link
                    to={CUSTOM_PRODUCT_DEVELOPMENT}
                    className="header-links__dropdown-link header-links__link"
                >
                    For enterprises
                </Link>
            </div>
        </div>
    );
};
export default Dropdown;
